import React from 'react';
import Icon from 'components/lib/icons/icon';

export default props => (
  <Icon viewBox="0 0 16 16" {...props}>
    <rect x="2.8" width="1.4" height="7" rx=".7" />
    <rect x="7" y="2.8" width="1.4" height="7" rx=".7" transform="rotate(90 7 2.8)" />
    <rect x="16" y="2.8" width="1.4" height="7" rx=".7" transform="rotate(90 16 2.8)" />
    <rect x="16" y="10" width="1.4" height="7" rx=".7" transform="rotate(90 16 10)" />
    <rect x="16" y="13" width="1.4" height="7" rx=".7" transform="rotate(90 16 13)" />
    <rect x="5.833" y="9" width="1.65" height="8.25" rx=".825" transform="rotate(45 5.833 9)" />
    <rect x="7" y="14.833" width="1.65" height="8.25" rx=".825" transform="rotate(135 7 14.833)" />
  </Icon>
);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/icons/symbols_icon.jsx